/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_DealInputs */

const en_deal_deal = /** @type {(inputs: Deal_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deal`)
};

/**
* | output |
* | --- |
* | "deal" |
*
* @param {Deal_DealInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const deal_deal = /** @type {((inputs?: Deal_DealInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_DealInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_deal_deal(inputs)
});